import * as React from 'react'

import { Card, Form } from 'tabler-react'
import Collapsible from 'react-collapsible'

export interface Props {
  functionalArea :any
  onFilterChange: any
}

class Filter extends React.Component<Props> {
  constructor(props){
    super(props)
    this.onFilterChange = this.onFilterChange.bind(this)
  }

  onFilterChange(e) {
    this.props.onFilterChange(e.target.name)
  }

  render () {
    const functionalArea = this.props.functionalArea
    return(
      <Card className='filter-wrapper'>
        <Form.Group label="Functional Area">
          {
            functionalArea.map((area, i) => {
              return(
                <Collapsible key={i} trigger={area.name}>
                 { area.secondaryArea.map((area, i) => {
                    return( <Form.Checkbox key={i}
                        label={area.name}
                        onChange={this.onFilterChange}
                        name={area.name}
                        checked={area.checked}
                        value={area.name}
                      />)
                  })}
                </Collapsible>
              )
            })
          }     
        </Form.Group>
      </Card>
    )
  }
}

export default Filter